import React from 'react';
import { Popover, Checkbox } from 'antd';
import { Translate } from '@above-the-treeline/localization';
import { FormContext } from '../FormContext';

export default function IsAccountSearchableForNewUsers() {
	const formContext = React.useContext(FormContext);
	const { formValuesById, setFormValuesById } = formContext;

	const inputId = 'isAccountSearchable';

	const onCheckboxChange = (e, id) => {
		setFormValuesById({
			...formValuesById,
			[id]: e.target.checked,
		});
	};

	const getPopoverContent = () => {
		const key = 'if_you_want_account_to_be_searchable_click_checkbox';

		return (
			<div className="is-account-searchable-help-popover-content">
				<Translate id={key} />
			</div>
		);
	};

	return (
		<div className="searchable-for-new-users-row">
			<Checkbox
				checked={formValuesById[inputId]}
				onChange={e => onCheckboxChange(e, inputId)}>
				<Translate id="make_account_searchable" />
			</Checkbox>
			<Popover
				placement="bottom"
				title={
					<b>
						<Translate id="account_search" />
					</b>
				}
				content={getPopoverContent()}
				trigger="hover">
				<span className="icon-help-icon" />
			</Popover>
		</div>
	);
}
